import axios from "axios"

const url = "https://wgzyjghcrf.execute-api.us-east-1.amazonaws.com/api"

const apiLambdaInsumo = axios.create({
    baseURL: url,
})

export default apiLambdaInsumo
